import { SessionState, TeamRole, SESSION_STATE, TEAM_ROLE } from '@run-diffusion/shared';

export const SERVER_ACTIONS = {
	REBOOT: 'rebootsd',
};
export const NEW_USER_PROMO_START_DATE: string = '2024-01-20T15:53:00Z'; // Saturday 8:53am
export const NEW_USER_PROMO_END_DATE: string = '2024-01-22T06:55:00Z'; // Sunday 11:55pm

export const EMAIL_REGEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape

export const SNACKBAR_STATUS: {
	ERROR: string
	SUCCESS: string
	WARN: string
	INFO: string
	ACCENT: string
} = {
	ERROR: 'ERROR',
	SUCCESS: 'SUCCESS',
	WARN: 'WARN',
	INFO: 'INFO',
	ACCENT: 'ACCENT',
};

interface TeamRoleDetails {
	id: TeamRole
	label: string
	description: string
}
export const TEAM_ROLE_DETAILS: {
	ADMIN: TeamRoleDetails
	CREATOR: TeamRoleDetails
} = {
	ADMIN: {
		id: TEAM_ROLE.ADMIN,
		label: 'Admin',
		description: 'Admins can add other team members',
	},
	CREATOR: {
		id: TEAM_ROLE.CREATOR,
		label: 'Creator',
		description: 'Creators can only generate images using either their team or personal storage',
	},
};

export const BOOTING_SESSION_STATES: SessionState[] = [
	SESSION_STATE.PURCHASE,
	SESSION_STATE.INIT,
	SESSION_STATE.BOOT,
];
export const READY_SESSION_STATES: SessionState[] = [
	SESSION_STATE.READY,
	SESSION_STATE.EXTEND,
];
export const STOPPING_SESSION_STATES: SessionState[] = [
	SESSION_STATE.STOP,
	SESSION_STATE.RECONCILE,
];
export const CURR_SESSION_STATES: SessionState[] = [
	...BOOTING_SESSION_STATES,
	...READY_SESSION_STATES,
	...STOPPING_SESSION_STATES,
];
export const PAST_SESSION_STATES: SessionState[] = [
	SESSION_STATE.STOPPED,
];
export const UPSELL_TYPE: {
	TEAM: string
	CREATORS_CLUB: string
} = {
	TEAM: 'TEAM',
	CREATORS_CLUB: 'CREATORS_CLUB',
};
export const TRAFFIC_SOURCE: {
	REDDIT: string
	YOUTUBE: string
	GOOGLE: string
	TIKTOK: string
	TWITTER: string
	INSTAGRAM: string
	DISCORD: string
	CIVITAI: string
	OTHER: string
} = {
	REDDIT: 'REDDIT',
	YOUTUBE: 'YOUTUBE',
	GOOGLE: 'GOOGLE',
	TIKTOK: 'TIKTOK',
	TWITTER: 'TWITTER',
	INSTAGRAM: 'INSTAGRAM',
	DISCORD: 'DISCORD',
	CIVITAI: 'CIVITAI',
	OTHER: 'OTHER',
};

export const REPORTS: {
	QUESTIONS: {},
	DASHBOARDS: {
		USER_USAGE_DASHBOARD: number
		COMPANY_USAGE_DASHBOARD: number
		TEAM_USAGE_DASHBOARD: number
		APP_USAGE_HOURS_DASHBOARD: number
		APP_USAGE_HOURS_COMPANY_DASHBOARD: number
	},
} = {
	QUESTIONS: {},
	DASHBOARDS: {
		USER_USAGE_DASHBOARD: 36,
		COMPANY_USAGE_DASHBOARD: 201,
		TEAM_USAGE_DASHBOARD: 265,
		APP_USAGE_HOURS_DASHBOARD: 397,
		APP_USAGE_HOURS_COMPANY_DASHBOARD: 430,
	},
};

export type RunnitsPublishedState = 'PUBLISHED' |
	'NOT_PUBLISHED'
	;
export const RUNNITS_PUBLISHED_STATE: Record<RunnitsPublishedState, RunnitsPublishedState> = {
	PUBLISHED: 'PUBLISHED',
	NOT_PUBLISHED: 'NOT_PUBLISHED',
};
